import { Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'
import type { OperatorIdentity } from '@/features/adviser-chat/lib/types'
import { AdviserRole } from '../lib/constants'
import { MessageBubble } from './MessageBubble'
import { OperatorAvatar } from './OperatorAvatar'

interface OperatorMessageProps {
  content: string
  operator: OperatorIdentity | null
}

export const OperatorMessage = ({
  content,
  operator,
}: OperatorMessageProps) => {
  const name = operator?.friendlyName || 'Heard team'

  return (
    <div className="w-full max-w-[640px] self-start py-2">
      <div className="mb-2 flex items-center gap-2">
        <OperatorAvatar operator={operator} />
        <Text
          variant={TypographyStyles.LABEL_SM}
          color={TextColors.HEADER}
          className="shrink-0"
        >
          {name}
        </Text>
      </div>
      <div className="rounded-tl-[4px] rounded-tr-[16px] rounded-br-[16px] rounded-bl-[16px] border border-neutral-200 bg-neutral-25 px-4 py-3">
        <MessageBubble role={AdviserRole.Operator} content={content} />
      </div>
    </div>
  )
}
